import { Boxes, Gift, PenTool, ArrowRight } from "lucide-react";
import Reveal from "@/components/Reveal";

const OFFERINGS = [
  {
    icon: PenTool,
    title: "Custom designs",
    text: "Dream it with us — a name in knot-work, birth-flowers set in resin, your palette in clay. We co-create one-of-one pieces with you, start to finish.",
    subject: "Custom design enquiry",
  },
  {
    icon: Gift,
    title: "Return gifts",
    text: "Weddings, housewarmings, baby showers and birthdays — handcrafted return gifts curated to your budget, packed and labelled ready to hand over.",
    subject: "Return gifts enquiry",
  },
  {
    icon: Boxes,
    title: "Bulk & corporate orders",
    text: "Festive hampers, event souvenirs and corporate gifting made in reliable batches — consistent finish, careful packaging and on-time delivery.",
    subject: "Bulk order enquiry",
  },
];

export default function Gifting() {
  return (
    <section
      id="gifting"
      className="mx-auto max-w-7xl scroll-mt-24 px-5 py-20 md:px-8 md:py-28"
      data-testid="gifting-section"
    >
      <Reveal>
        <div className="mb-12 max-w-2xl">
          <p className="label-mono">Gifts &amp; bulk orders</p>
          <h2 className="mt-3 font-display text-4xl tracking-tight sm:text-5xl">
            Made for moments, made in batches, made for you.
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-stone2">
            Beyond the shelf, the studio takes on made-to-order work. Share your idea, date and
            quantities — we reply within a day.
          </p>
        </div>
      </Reveal>
      <div className="grid gap-6 md:grid-cols-3">
        {OFFERINGS.map((o, i) => (
          <Reveal key={o.title} delay={i * 0.08} className="h-full">
            <div
              className="group flex h-full flex-col border border-line bg-white p-8 transition-colors duration-300 hover:border-ink"
              data-testid={`gifting-card-${i}`}
            >
              <span className="grid h-12 w-12 place-items-center rounded-full border border-line bg-cream text-terracotta transition-colors duration-300 group-hover:bg-terracotta group-hover:text-white">
                <o.icon size={20} strokeWidth={1.5} />
              </span>
              <h3 className="mt-6 font-display text-2xl">{o.title}</h3>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-stone2">{o.text}</p>
              <a
                href={`mailto:hello@knotandcast.in?subject=${encodeURIComponent(o.subject)}`}
                className="mt-6 inline-flex items-center gap-2 text-sm font-semibold transition-colors hover:text-terracotta"
                data-testid={`gifting-cta-${i}`}
              >
                Start an enquiry
                <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
              </a>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2}>
        <p
          className="mt-10 font-mono text-[11px] uppercase tracking-[0.2em] text-stone-400"
          data-testid="gifting-contact-line"
        >
          Write to hello@knotandcast.in with dates, quantities and ideas — custom work starts from
          a conversation.
        </p>
      </Reveal>
    </section>
  );
}
